import { useState, useRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";

function Gallery(props) {
  const total = props.items.slide.length;
  const [current, setCurrent] = useState(1);
  const currentSlideTitle = props.items.slide[current - 1]?.title;
  const showDots = total <= 10;
  const splideRef = useRef(null);

  return (
    <section className="layout layout__color_primary">
      <Container fluid>
        <Splide
          ref={splideRef}
          className="splide_custom"
          aria-label="My Favorite Images"
          hasTrack={false}
          options={{
            gap: "40px",
            arrows: false,
            pagination: showDots,
            type: "fade",
            rewind: true,
            paginationDirection: "ltr",
            breakpoints: {
              992: {
                arrows: false,
              },
            },
          }}
          onMove={(splide) => setCurrent(splide.index + 1)}
        >
          <Row className="position-relative">
            <Col
              lg={3}
              xl={4}
              className="layout_mb__30 d-flex flex-column justify-content-between"
            >
              <div>
                <h2 data-aos="fade-up">{props.items.title}</h2>
              </div>
              <div>
                {currentSlideTitle && (
                  <h3
                    data-aos="fade-up"
                    className="layout_subtitle mb-lg-4 mt-4"
                  >
                    {currentSlideTitle}
                  </h3>
                )}
                {!showDots && (
                  <div
                    className="splide__arrows d-none d-lg-flex gap-4 align-items-center"
                    data-aos="fade-up"
                  >
                    <button
                      className="splide__arrow splide__arrow--prev"
                      onClick={() => splideRef.current?.splide?.go("<")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="22"
                        viewBox="0 0 11 22"
                        fill="none"
                      >
                        <path
                          d="M2 2L9.5 11L2 20"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </button>

                    <div className="h3 splide__counter">
                      {String(current).padStart(2, "0")}/
                      {String(total).padStart(2, "0")}
                    </div>

                    <button
                      className="splide__arrow splide__arrow--next"
                      onClick={() => splideRef.current?.splide?.go(">")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="22"
                        viewBox="0 0 11 22"
                        fill="none"
                      >
                        <path
                          d="M2 2L9.5 11L2 20"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </button>
                  </div>
                )}
              </div>
            </Col>
            <Col>
              <SplideTrack className="w-100">
                {props.items.slide.map((item, index) => {
                  return (
                    <SplideSlide
                      data-aos="fade-up"
                      className="splide__slide__full"
                      key={`photo_${index}`}
                    >
                      <img
                        src={
                          process.env.REACT_APP_BACKEND_URL +
                          item.thumb.data.attributes.url
                        }
                        alt={`photo_${index}`}
                        className="autoImg layout_image layout_image__round mb-4 mb-lg-0"
                      />
                    </SplideSlide>
                  );
                })}
              </SplideTrack>
              <div
                className={`splide__arrows d-flex d-lg-none gap-4 align-items-center justify-content-end ${showDots && "only_right"}`}
              >
                <button
                  data-aos="fade-up"
                  className="splide__arrow splide__arrow--prev"
                  onClick={() => splideRef.current?.splide?.go("<")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="22"
                    viewBox="0 0 11 22"
                    fill="none"
                  >
                    <path
                      d="M2 2L9.5 11L2 20"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </button>
                {!showDots && (
                  <div className="h3 splide__counter">
                    {String(current).padStart(2, "0")}/
                    {String(total).padStart(2, "0")}
                  </div>
                )}
                <button
                  data-aos="fade-up"
                  className="splide__arrow splide__arrow--next"
                  onClick={() => splideRef.current?.splide?.go(">")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="22"
                    viewBox="0 0 11 22"
                    fill="none"
                  >
                    <path
                      d="M2 2L9.5 11L2 20"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </button>
              </div>
            </Col>
          </Row>
        </Splide>
      </Container>
    </section>
  );
}

export default Gallery;
